import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_a33d4f0cb9: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_a33d4f0cb9",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Wildflower Whimsy",
  description:
    "Celebrate nature with floral-inspired ceramics and dried botanicals that complement your existing collection of hand-painted home accents.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/a7ebd4add3725214e648c24922380c8d11fb88e43dc9112c504e71c0c3784927.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/a7ebd4add3725214e648c24922380c8d11fb88e43dc9112c504e71c0c3784927.jpeg",
    "https://cdn.faire.com/fastly/cdd95f0c7d02f49ea3418a580ef7977d47cce3b07d0e2b43b4b8a3376eee4a8f.jpeg",
    "https://cdn.faire.com/fastly/b405f053c8b4d7492760e8a4256957b7110f299d64d16906324afb666ef371b1.jpeg",
    "https://cdn.faire.com/fastly/7acf71d0e9274065f724eadd1b9e62f73b960ee27660d6ed45818de6defd38e7.jpeg",
    "https://cdn.faire.com/fastly/1d163fd6f695695e5a5bd4228c9735ca43c81e636a3b19b2440d662c6d83dd3b.jpeg",
    "https://cdn.faire.com/fastly/0906fab7e96152e1eff6065bbf1980d17ae1c62c802a668f313bf39be7f582e9.jpeg",
  ],
  itemCount: 55,
  source: "eric_themes_ideas",
  teaser: "thi_a33d4f0cb9",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
